enum ColorTheme {
  DARK = 'dark',
  LIGHT = 'light',
}

export default ColorTheme;
